import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "./firebase";
import { useNavigate } from "react-router-dom";
import "./BillingSystem.css";

export default function TokenHistoryPage({ role }) {
  const [invoices, setInvoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const invoiceRef = ref(database, "invoices");
    onValue(invoiceRef, (snapshot) => {
      const data = snapshot.val() || {};
      const list = Object.entries(data).map(([id, value]) => ({
        id,
        ...value,
      }));
      setInvoices(list);
    });
  }, []);

  const filteredInvoices = invoices.filter((inv) =>
    inv.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    inv.token?.toString().includes(searchTerm)
  );

  return (
    <div className="container">
      <div className="section">
        <h2>Token History</h2>

        <div style={{ marginBottom: 20 }}>
          <button onClick={() => navigate(-1)}>← Back</button>
        </div>

        <input
          type="text"
          placeholder="Search by name or token number"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="input"
          style={{ width: "100%", marginBottom: 20 }}
        />

        {filteredInvoices
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .map((inv) => (
            <div key={inv.id} className="token-card">
              <strong>#{inv.token} - {inv.name}</strong>
              <br />
              <span>Date: {inv.date}</span>
              <ul>
                {inv.items?.map((item, idx) => (
                  <li key={idx}>{item.quantity} x {item.product}</li>
                ))}
              </ul>
            </div>
        ))}
      </div>
    </div>
  );
}
